import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import NavigationDrawer from "../../components/navigationDrawer";
import { getAllCustomer } from "../../services/customerFn";
import { getAllProvider } from "../../services/providerFn";
import MessageBox from "./MessageBox";
import AllUsers from "./Users";
import AppLoader from "../../components/loader/loader";
import { getDatabase, off, onValue, ref } from "firebase/database";
import { useSelector } from "react-redux";
import CustomBar from "../../components/customBar";

function Chat() {
  const [providerData, setProviderData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const { selectedChat } = useSelector((state) => state.activeChat);
  const { user } = useSelector((state) => state.user);
  const [searchVall, setSearchVall] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCustomerData();
    fetchProviderData();
  }, []);

  useEffect(() => {
    if (selectedChat) {
      try {
        const messagesRef = ref(
          getDatabase(),
          `messages/${user?._id}/${selectedChat?._id}`
        );

        const handleDataSnapshot = (snapshot) => {
          const data = snapshot.val();
          if (data !== null) {
            const tempArr = Object.keys(data).map((key) => {
              const item = data[key];
              return {
                sendBy: item?.sender,
                ReceivedBy: item?.receiver,
                msg: item?.msg,
                time: item?.time,
                attachmentUrl: item?.attachmentUrl || null,
              };
            });
            console.log(tempArr, "Selected Chat Messages");
          }
        };

        onValue(messagesRef, handleDataSnapshot);
        return () => off(messagesRef, "value", handleDataSnapshot);
      } catch (error) {
        console.log(error, "Chat listener error");
      }
    }
  }, [selectedChat]);

  useEffect(() => {
    if (user?._id) {
      const userMessagesRef = ref(getDatabase(), `messages/${user._id}`);

      const handleUserMessages = (snapshot) => {
        const allChats = snapshot.val();
        const chatSummary = {};

        if (allChats) {
          Object.keys(allChats).forEach((chatUserId) => {
            const messages = allChats[chatUserId];
            const msgArray = Object.values(messages).sort(
              (a, b) => b.time - a.time
            );

            const unreadCount = msgArray.filter(
              (msg) => msg.receiver === user._id && !msg.read
            ).length;

            const lastMsg = msgArray[0];

            chatSummary[chatUserId] = {
              lastMessage: lastMsg?.msg || "",
              lastMessageTime: lastMsg?.time || null,
              unreadCount,
            };
          });

          const updateList = (list) =>
            list.map((u) => {
              const extra = chatSummary[u._id] || {};
              return { ...u, ...extra };
            });

          setCustomerData((prev) => updateList(prev));
          setProviderData((prev) => updateList(prev));
        }
      };

      onValue(userMessagesRef, handleUserMessages);
      return () => off(userMessagesRef, "value", handleUserMessages);
    }
  }, [user?._id]);

  const fetchCustomerData = async () => {
    try {
      setLoading(true);
      const response = await getAllCustomer();
      if (response.data.status === "success") {
        setCustomerData(response.data.data);
      } else {
        console.log("Customer fetch error", response.data?.message);
      }
    } catch (error) {
      console.error("Customer fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProviderData = async () => {
    try {
      setLoading(true);
      const response = await getAllProvider();
      if (response.data.status === "success") {
        setProviderData(response.data.data);
      } else {
        console.log("Provider fetch error", response.data?.message);
      }
    } catch (error) {
      console.error("Provider fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const sortByLatest = (a, b) => {
    return (b.lastMessageTime || 0) - (a.lastMessageTime || 0);
  };

  const filteredProviders = providerData
    .filter((user) => {
      const fullName = `${user.firstname} ${user.lastname}`.toLowerCase();
      return fullName.includes(searchVall.toLowerCase());
    })
    .sort(sortByLatest);

  const filteredCustomers = customerData
    .filter((user) => {
      const fullName = `${user.firstname} ${user.lastname}`.toLowerCase();
      return fullName.includes(searchVall.toLowerCase());
    })
    .sort(sortByLatest);

  return (
    <NavigationDrawer>
      <AppLoader isVisible={loading} />
      <CustomBar title={"CHAT"} />
      <Grid container spacing={1}>
        <Grid item xs={12} md={3.5}>
          <AllUsers
            businessList={filteredProviders}
            usersList={filteredCustomers}
            searchVall={searchVall}
            setSearchVall={setSearchVall}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={8.5}
          sx={{ display: { xs: "none", md: "block" } }}
        >
          <MessageBox />
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default Chat;
